import Component from './AddForm.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionAddForm', Component);
  },
};
